module.exports = __webpack_public_path__ + "img/logo_maxim.541e9e1e.png";